// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/tooltip.js
import Overlay from "./overlay"
let overlayId = 0

export default class Tooltip extends Overlay {
  static componentName = "tooltip"

  createTip() {
    const title = this.config.title || this.element.dataset.coreuiOriginalTitle
    if (!title) return null
    const tip = document.createElement("div")
    tip.id = `coreui-tooltip-${++overlayId}`
    tip.className = "tooltip fade"
    tip.setAttribute("role", "tooltip")
    tip.innerHTML = '<div class="tooltip-arrow"></div><div class="tooltip-inner"></div>'
    this.setContent(tip.querySelector(".tooltip-inner"), title)
    return tip
  }
}
